import * as PIXI from 'pixi.js';
import type { UpdateFlowMixinSettings } from '../updateFlowMixin';
import { TypedUpdateFlowMixin } from '../updateFlowMixin';
import { ColorAttribute } from '../attributes';
import type { SerializableMixinSettings } from '../serializableMixin';
import { TypedSerializableMixin } from '../serializableMixin';

type AssetBoundsDisplaySettings = {
    strokeColor?: number;
    asset: object;
    referenceToOutputMultiplier?: number;
} & UpdateFlowMixinSettings &
    SerializableMixinSettings;

export class AssetBoundsDisplay extends TypedUpdateFlowMixin(
    TypedSerializableMixin(PIXI.Graphics),
) {
    override name = 'assetBoundsDisplay';
    @ColorAttribute()
    accessor strokeColor = 0;
    #strokeWidthInOutputResolution = 3;
    asset: object | undefined = undefined;
    #referenceToOutputMultiplier: number;

    constructor(settings: AssetBoundsDisplaySettings) {
        super(settings);
        this.strokeColor = settings.strokeColor ?? this.strokeColor;
        this.asset = settings.asset;
        this.#referenceToOutputMultiplier = settings.referenceToOutputMultiplier ?? 1;
    }

    override _update() {
        if (!this.asset) {
            return;
        }
        this.clear();
        const { x, y, width, height } = (
            this.asset as { getBounds: () => PIXI.Rectangle }
        ).getBounds();
        const strokeWidth = Math.max(
            1,
            Math.round(this.#strokeWidthInOutputResolution / this.#referenceToOutputMultiplier),
        );
        this.lineStyle(strokeWidth, this.strokeColor, 1);
        this.drawRect(x, y, width, height);
    }
}
